export default __webpack_public_path__ + "static/media/Delivered.2bb9e104.png";